module.exports = __webpack_public_path__ + "assets/clapping_hands.0dddecb7ff8462472cf251d64a3aef9b.png";